import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["aria-checked", "disabled", "aria-disabled"]
const _hoisted_2 = { class: "dropdown-item-after" }

import { Checkbox as RcCheckbox } from '@components/Form/Checkbox';
import { RcIcon } from '@components/RcIcon';
import { useDropdownItem } from '@components/RcDropdown/useDropdownItem';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcDropdownItemCheckbox',
  props: {
    modelValue: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    indicator: { default: 'checkbox' }
  },
  emits: ['click', 'update:modelValue'],
  setup(__props: any, { emit: __emit }) {

/**
 * An item for a dropdown menu that is turned on and off, and stays open for the next one. Used in
 * conjunction with RcDropdown.
 *
 * `indicator="checkmark"` marks it checked with a checkmark at its end rather than a checkbox, for a
 * list of things shown and hidden; `#before` then holds anything leading the label.
 */
const props = __props;
const emits = __emit;

const {
  handleKeydown, handleActivate, scrollIntoView, handleMouseenter
} = useDropdownItem();

const handleClick = () => {
  if (props.disabled) {
    return;
  }

  emits('click', !props.modelValue);
  emits('update:modelValue', !props.modelValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: "dropdownMenuItem",
    "dropdown-menu-item": "",
    tabindex: "-1",
    role: "menuitemcheckbox",
    "aria-checked": __props.modelValue,
    disabled: __props.disabled || null,
    "aria-disabled": __props.disabled || false,
    onClick: _withModifiers(handleClick, ["stop"]),
    onKeydown: [
      _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_unref(handleActivate) && _unref(handleActivate)(...args)), ["enter","space"])),
      _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_unref(handleKeydown) && _unref(handleKeydown)(...args)), ["prevent","stop"]), ["up","down"]))
    ],
    onMousedown: _withModifiers(() => {/* As RcDropdownItem: a click doesn't take the focus */}, ["prevent"]),
    onFocusin: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(scrollIntoView) && _unref(scrollIntoView)(...args))),
    onMouseenter: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(handleMouseenter) && _unref(handleMouseenter)(...args)))
  }, [
    (__props.indicator === 'checkmark')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _renderSlot(_ctx.$slots, "before"),
          _cache[4] || (_cache[4] = _createTextVNode()),
          _renderSlot(_ctx.$slots, "default"),
          _cache[5] || (_cache[5] = _createTextVNode()),
          _createElementVNode("span", _hoisted_2, [
            (__props.modelValue)
              ? (_openBlock(), _createBlock(_unref(RcIcon), {
                  key: 0,
                  type: "checkmark",
                  size: "inherit"
                }))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : (_openBlock(), _createBlock(_unref(RcCheckbox), {
          key: 1,
          value: __props.modelValue
        }, {
          label: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["value"]))
  ], 40, _hoisted_1))
}
}

})